import React from "react";
import Divider from '@material-ui/core/Divider';
import theme from "../constants/theme";
const { primary } = theme.palette;

export default () => <Divider style={{ backgroundColor: primary.main, height: 2, marginTop: 10, marginBottom: 20 }}/>



// WEBPACK FOOTER //
// ./src/components/PrimaryDivider.js